// extracted by mini-css-extract-plugin
module.exports = {"container":"Chat_container__2s9_1","spinner":"Chat_spinner__1ft9s","default":"Chat_default__1_WnC","emptyUsersContainer":"Chat_emptyUsersContainer__2AIb2"};